import { Injectable } from '@angular/core';
import {
  NgEntityService,
  NgEntityServiceConfig,
} from '@datorama/akita-ng-entity-service';
import { tap } from 'rxjs/operators';

import { RequestStatus } from './request.model';
import { RequestState, RequestStore } from './request.store';

@Injectable()
@NgEntityServiceConfig({
  resourceName: 'requests',
})
export class RequestService extends NgEntityService<RequestState> {
  constructor(protected store: RequestStore) {
    super(store);
  }

  approve(id: string) {
    return this.getHttp()
      .put(`${this.api}/${id}/status`, {
        status: RequestStatus.Accepted,
      })
      .pipe(
        tap(() => {
          this.store.remove(id);
        })
      );
  }
  reject(id: string) {
    return this.getHttp()
      .put(`${this.api}/${id}/status`, {
        status: RequestStatus.Rejected,
      })
      .pipe(
        tap(() => {
          this.store.remove(id);
        })
      );
  }
  
  removeById(id: string) {
    this.store.remove(id);
  }

  setStatus(id: string, status: RequestStatus) {
    this.store.update(id, {status})
  }
}
